<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules" label-width="136px">
        <el-form-item class="half" label="资金金额" prop="fundsAmount">
          <el-input v-model.trim="dialogForm.fundsAmount" clearable @input="handleInput" @blur="handleBlur"
            :placeholder="'请输入资金金额'" />
        </el-form-item>
        <el-form-item class="half" label="收付款类型" prop="payType">
          <el-select-dict :dictType="{ type: 'PAY_TYPE', filters: '3', reverse: true }" clearable placeholder="请选择收付款类型"
            v-model="dialogForm.payType"></el-select-dict>
        </el-form-item>
        <el-form-item class="half" label="关联用户类型">
          <el-radio-dict v-model="customerType" dictType="CUSTOMER_TYPE"></el-radio-dict>
        </el-form-item>
        <el-form-item class="half" :label="customerType === '1' ? '关联客户' : '关联供应商'" prop="customerName">
          <div class="box flex-c-s">
            <el-input disabled readonly v-model.trim="dialogForm.customerName" clearable
              :placeholder="customerType === '1' ? '选择关联客户' : '选择关联供应商'"></el-input>
            <el-button type="primary" size="mini" class="get-button" @click="showSelectCustomer = true">搜索</el-button>
          </div>
        </el-form-item>

        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
        <el-form-item class="all" label="">
          <el-checkbox v-model="checked">我已知晓：<span
              style="color: #F56C6C">“新增成功后账单不可删除，不可编辑”</span>，请仔细检查填写的内容，请确认无误后再进行新增。</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </template>
    </div>

    <select-customer ref="selectCustomer" :customerType="customerType" title="选择关联客户/供应商" width="1000px" :modal="true"
      :visible.sync="showSelectCustomer" @handleSelect="handleSelectCustomer" @close="showSelectCustomer = false"
      :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false" />
  </el-dialog>
</template>
<script>
import SelectCustomer from "@/components/select-customer/index.vue"
import { billApi } from "@/api"
export default {
  name: "PaidRecord",
  components: {
    SelectCustomer
  },
  data() {

    return {
      customerType: "1", // 客户类型
      showSelectCustomer: false,
      checked: false, // 是否已知晓
      dialogForm: {
        fundsAmount: "", // 资金金额
        customerName: "", // 关联客户/供应商
        payType: "", // 收付款类型
        customerId: "", // 关联客户/供应商
        profiAmount: "", // 盈利金额 与资金金额 一致
        remark: "" // 备注
      }, // 弹框表单
      // 表单校验
      rules: {
        fundsAmount: [
          { required: true, message: "请输入资金金额", trigger: "blur" }
        ],
        customerName: [
          { required: true, message: "请选择关联客户", trigger: "change" }
        ],
        payType: [
          { required: true, message: "请选择收付款类型", trigger: "change" }
        ],
        remark: [
          { required: true, message: "请输入账单备注", trigger: "blur" }
        ] // 备注
      }
    }
  },
  watch: {
    showSelectCustomer(val) {
      if (!val) {
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()

        // 重置表单
        this.$refs.selectCustomer.resetQuery()
      }
    }
  },
  methods: {
    // 选择供应商
    handleSelectCustomer(row) {
      this.showSelectCustomer = false

      // 关闭前调整遮罩层
      this.mixinRemoveAndAddMask()

      this.$set(this.dialogForm, "customerId", row.customerId)
      this.$set(this.dialogForm, "customerName", row.customerName)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.validateField("customerName")
      })
    },
    // 失去焦点事件
    handleBlur() {
      // 若输入值不为空
      if (this.dialogForm["fundsAmount"]) {
        // 将输入值转换为浮点数
        const num = parseFloat(this.dialogForm["fundsAmount"])
        // 判断是否为有效的数字
        if (!isNaN(num)) {
          // 保留两位小数
          this.dialogForm["fundsAmount"] = num.toFixed(2)
        }
      }
    },
    // 输入事件
    handleInput() {
      let value = this.dialogForm["fundsAmount"]
      // 移除非数字和小数点的字符
      value = value.replace(/[^\d.]/g, "")
      // 处理多个小数点的情况
      const parts = value.split(".")
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1]
      }
      // 保留最多两位小数
      const match = value.match(/^\d+(\.\d{0,2})?/)
      if (match) {
        this.dialogForm["fundsAmount"] = match[0]
      } else {
        this.dialogForm["fundsAmount"] = ""
      }
    },

    // 重置表单
    resetForm() {
      this.$nextTick(() => {
        this.checked = false
        this.$refs.dialogFormRef && this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    async submitForm() {
      const _this = this
      this.$refs["dialogFormRef"].validate(async(valid) => {
        if (valid) {
          if (!this.checked) {
            await this.$modal.confirm("新增成功后记录不可删除，不可编辑，确认本次新增信息无误？", {
              beforeClose: (action, instance, done) => {
                // 关闭前调整遮罩层
                _this.mixinRemoveAndAddMask()
                done()
              }
            })
          }
          //新增
          this.dialogForm.fundsAmount = this.dialogForm.payType === "1" ? "-" + this.dialogForm.fundsAmount : this.dialogForm.fundsAmount
          this.dialogForm.profiAmount = this.dialogForm.fundsAmount
          billApi.createItem(this.dialogForm).then((data) => {
            this.$modal.msgSuccess("新增账单成功")
            this.$emit("close")
            this.$emit("successs")
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog__body {
  .get-button {
    position: absolute;
    width: 88px;
    right: 4px;
    top: 50%;
    transform: translateY(calc(-50% + 2px));
  }
}
</style>